import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 引入样式
import '@/style/index.less';
// 引入banner组件
import Banner from '@/components/banner';
// 引入页脚组件
import Footer from './components/footer';
Vue.config.productionTip = false
Vue.use(ElementUI);
// 注册页脚组件
Vue.component('my-footer', Footer);
// 注册banner组件
Vue.component('banner', Banner);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
